import { render, staticRenderFns } from "./AppComplaintThanks.vue?vue&type=template&id=0c77977c&"
import script from "./AppComplaintThanks.vue?vue&type=script&lang=js&"
export * from "./AppComplaintThanks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports